import React from 'react';
import { useMsal } from '@azure/msal-react';

/**
 * Shown when the user signed in with Microsoft but has no PolicyLens app role on the Enterprise Application.
 */
const NotInvitedPage = ({ userName, userEmail }) => {
    const { instance } = useMsal();

    const handleSignOut = () => {
        instance.logoutRedirect({
            postLogoutRedirectUri: window.location.origin,
        }).catch((err) => console.error('Logout failed:', err));
    };

    return (
        <div
            style={{
                minHeight: 'calc(100vh / var(--app-zoom))',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 24,
                background: 'linear-gradient(180deg, var(--color-bg-base) 0%, var(--color-border) 100%)',
            }}
        >
            <div
                style={{
                    maxWidth: 440,
                    width: '100%',
                    background: 'var(--color-bg-white)',
                    borderRadius: 24,
                    padding: '40px 36px',
                    boxShadow: '0 25px 50px -12px rgba(15, 23, 42, 0.15)',
                    border: '1px solid var(--color-border)',
                    textAlign: 'center',
                }}
            >
                <div
                    style={{
                        width: 56,
                        height: 56,
                        margin: '0 auto 20px',
                        borderRadius: 16,
                        background: 'var(--color-accent-fill)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'var(--color-bg-white)',
                        fontWeight: 900,
                        fontSize: 22,
                    }}
                >
                    P
                </div>
                <h1 style={{ fontSize: 22, fontWeight: 800, color: 'var(--color-text-hero)', margin: '0 0 12px', letterSpacing: '-0.02em' }}>
                    No access yet
                </h1>
                <p style={{ color: 'var(--color-text-muted)', fontSize: 15, lineHeight: 1.6, margin: '0 0 8px' }}>
                    Your account <strong style={{ color: 'var(--color-text-muted-dark)' }}>{userEmail || '-'}</strong> is signed in, but you are{' '}
                    <strong style={{ color: 'var(--color-text-muted-dark)' }}>not assigned a PolicyLens role</strong> in the enterprise application.
                </p>
                <p style={{ color: 'var(--color-text-muted)', fontSize: 13, lineHeight: 1.5, margin: '0 0 28px' }}>
                    Ask your administrator to assign you a role (for example Platform admin, Lead Advisor, or Advisor) in Microsoft
                    Entra ID, then sign in again.
                </p>
                {userName && (
                    <p style={{ color: 'var(--color-text-muted)', fontSize: 12, marginBottom: 24 }}>
                        Signed in as {userName}
                    </p>
                )}
                <button
                    type="button"
                    onClick={handleSignOut}
                    style={{
                        width: '100%',
                        padding: '14px 20px',
                        borderRadius: 12,
                        border: 'none',
                        background: 'var(--color-text-hero)',
                        color: 'var(--color-bg-white)',
                        fontSize: 13,
                        fontWeight: 700,
                        letterSpacing: '0.08em',
                        textTransform: 'uppercase',
                        cursor: 'pointer',
                    }}
                >
                    Sign out
                </button>
            </div>
        </div>
    );
};

export default NotInvitedPage;
